module.exports = __webpack_public_path__ + "img/logo_mhy.177a4684.png";